import type { AdminScreenState } from "../../contracts/admin-screen-state";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";
import { localizeAdminQueryError } from "./localize-admin-query-error";
import { normalizeAdminQueryError } from "./normalize-admin-query-error";

export function toAdminScreenErrorState<TViewModel>(
  locale: AdminDashboardLocale,
  error: unknown,
): AdminScreenState<TViewModel> {
  const normalizedError = localizeAdminQueryError(normalizeAdminQueryError(error), locale);

  if (normalizedError.code === "ADMIN_QUERY_PERMISSION_DENIED") {
    return {
      status: "permission_denied",
      error: normalizedError,
    };
  }

  return {
    status: "error",
    error: normalizedError,
  };
}
